import { track } from './analytics';
import { appCheckToken } from './firebase';
import { useState } from 'react';
import { Link } from 'react-router-dom';
export function DemoForm() {
  const [status, setStatus] = useState('');
  const [state, setState] = useState<'success' | 'error' | ''>('');
  const [busy, setBusy] = useState(false);
  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.reportValidity()) return;
    setBusy(true);
    setState('');
    setStatus('Sending your request…');
    try {
      // The Pages Function on this origin (functions/api/request-demo.ts).
      const endpoint = '/api/request-demo';
      const token = await appCheckToken();
      const body = Object.fromEntries(new FormData(form).entries());
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          ...(token ? { 'X-Firebase-AppCheck': token } : {}),
        },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        const value = await response.json().catch(() => ({}));
        throw new Error(value.error || 'We could not send your request. Please try again.');
      }
      form.reset();
      setStatus('Thank you. We will call you back shortly to set up your demo.');
      setState('success');
      track('demo_submit');
    } catch (error) {
      setStatus(
        error instanceof Error
          ? error.message
          : 'We could not send your request. Please try again.',
      );
      setState('error');
      track('demo_error');
    } finally {
      setBusy(false);
    }
  }
  return (
    <form
      className="card demo-form"
      onSubmit={submit}
      onFocus={() => track('demo_start')}
      noValidate
    >
      <div className="form-grid">
        <Field label="Your name" name="name" required autoComplete="name" />
        <Field
          label="Mobile number"
          name="phone"
          type="tel"
          required
          autoComplete="tel"
          pattern="\+?[0-9 ]{10,20}"
          title="A number we can call you back on, for example 98765 43210"
        />
        <Field label="Company (optional)" name="company" autoComplete="organization" />
        <Field label="Email (optional)" name="email" type="email" autoComplete="email" />
        <div className="field full">
          <label htmlFor="requirements">Anything you would like us to cover? (optional)</label>
          <textarea id="requirements" name="requirements" maxLength={2000} />
        </div>
        <div className="hp" aria-hidden="true">
          <label>
            Website
            <input name="website" tabIndex={-1} autoComplete="off" />
          </label>
        </div>
      </div>
      <button className="button primary" type="submit" disabled={busy}>
        Request my demo
      </button>
      <div className="form-status" data-state={state} role="status" aria-live="polite">
        {status}
      </div>
      <small>
        We use these details only to call you back about the demo — never for a marketing list. See
        our <Link to="/privacy">privacy policy</Link>.
      </small>
    </form>
  );
}
function Field({
  label,
  name,
  type = 'text',
  required = false,
  ...input
}: {
  label: string;
  name: string;
  type?: string;
  required?: boolean;
  autoComplete?: string;
  pattern?: string;
  title?: string;
}) {
  return (
    <div className="field">
      <label htmlFor={name}>{label}</label>
      <input id={name} name={name} type={type} required={required} maxLength={160} {...input} />
    </div>
  );
}
